"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendPlayerURLBodyToJSON = exports.SendPlayerURLBodyFromJSONTyped = exports.SendPlayerURLBodyFromJSON = void 0;
function SendPlayerURLBodyFromJSON(json) {
    return SendPlayerURLBodyFromJSONTyped(json, false);
}
exports.SendPlayerURLBodyFromJSON = SendPlayerURLBodyFromJSON;
function SendPlayerURLBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'playerID': json['playerID'],
        'useSMS': json['useSMS'],
        'useEmail': json['useEmail'],
    };
}
exports.SendPlayerURLBodyFromJSONTyped = SendPlayerURLBodyFromJSONTyped;
function SendPlayerURLBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'playerID': value.playerID,
        'useSMS': value.useSMS,
        'useEmail': value.useEmail,
    };
}
exports.SendPlayerURLBodyToJSON = SendPlayerURLBodyToJSON;
